export default {
  action: 'การดำเนินการ',
  actionBlockedDueToDuplicateUuid:
    'ถูกระงับการดำเนินการเนื่องจาก UUID ของอุปกรณ์ซ้ำกัน',
  active: 'ใช้งานอยู่',
  add: 'เพิ่ม',
  addAnotherIp: 'เพิ่ม IP อื่น',
  addDeviceHeaderwoSuite: 'เพิ่มอุปกรณ์: {{screen}}',
  addDevices: 'เพิ่มอุปกรณ์',
  addIp: 'เพิ่ม IP',
  addIPAddress: 'เพิ่มที่อยู่ IP',
  addIpHeader: 'เพิ่มที่อยู่ IP: {{screen}}',
  addRole: 'เพิ่มบทบาท',
  addSuite: 'เพิ่มชุดอุปกรณ์ Suite',
  addSuiteHeader: 'เพิ่มชุดอุปกรณ์ Suite: {{screen}} - ชุดอุปกรณ์ {{suite}}',
  adminRoleWillHaveFullAccess: 'บทบาทผู้ดูแลระบบจะได้รับการเข้าถึงเต็มรูปแบบ',
  all: 'ทั้งหมด',
  and: 'และ',
  applianceStatus: 'สถานะเครื่องใช้/อุปกรณ์',
  apply: 'ประยุกต์ใช้',
  assignedToDevice: 'มอบหมายให้กับอุปกรณ์แล้ว',
  availableDevices: 'อุปกรณ์ที่พร้อมใช้งาน',
  bookingDate: 'วันที่จอง',
  bookingRef: 'หมายเลขอ้างอิง',
  bulkEditScreenIPs: 'แก้ไข IP ของหน้าจอแบบเป็นชุด',
  bulkHeadingMsg:
    'การเปลี่ยนแปลง IP ที่นี่จะส่งผลไปยังอุปกรณ์หน้าจอทั้งหมดที่เกี่ยวข้อง',
  cancel: 'ยกเลิก',
  ccEmails: 'อีเมล CC',
  certificateAutoSync: 'ซิงค์ใบรับรองอัตโนมัติ',
  certificateExpired: 'ใบรับรองหมดอายุแล้ว',
  certificateForAllDevicesMustBeValid:
    'ใบรับรองสำหรับอุปกรณ์ทั้งหมดต้องยังไม่หมดอายุ',
  certificateNotAvailable: 'ไม่มีใบรับรองอุปกรณ์สำหรับหมายเลขซีเรียลนี้',
  certificateNotValid: 'ใบรับรองไม่ถูกต้อง',
  chain: 'เครือโรงภาพยนตร์',
  chainSmall: 'เครือโรงภาพยนตร์',
  changesSavedSuccessfully: 'บันทึกการเปลี่ยนแปลงเรียบร้อยแล้ว',
  clear: 'ล้าง',
  clearAll: 'ล้างทั้งหมด',
  clearAllSmall: 'ล้างทั้งหมด',
  clearSelection: 'ล้างการเลือก',
  collapseAll: 'ย่อทั้งหมด',
  common: {
    confirm: 'ยืนยัน',
  },
  composition: 'คอมโพสิชั่นภาพยนตร์',
  compositionCount_one: 'องค์ประกอบ (1)',
  compositionCount_other: 'องค์ประกอบ{{plural}} ({{count}})',
  compositionDetails: 'รายละเอียดองค์ประกอบ',
  compositionName: 'ชื่อองค์ประกอบ',
  confirmDelete: 'ยืนยันการลบ',
  confirmDeleteIP: 'คุณแน่ใจหรือไม่ว่าต้องการลบที่อยู่ IP {{ip}}?',
  confirmDeleteIPAssigned:
    'IP นี้ถูกมอบหมายอยู่และจะถูกตัดการเชื่อมต่อจากอุปกรณ์: {{deviceInfo}} ที่ {{location}}',
  confirmDeleteSuite:
    'คุณแน่ใจหรือไม่ว่าต้องการลบ {{screen_name}} - ชุดอุปกรณ์ {{suite_number}}? กรุณาเลือกตัวเลือกที่เหมาะสมเพื่อดำเนินการต่อ',
  content: 'เนื้อหา',
  contentDetails: 'รายละเอียดเนื้อหา',
  copyLink: 'คัดลอกลิงก์',
  countTheatres_one: '1 โรงภาพยนตร์',
  countTheatres_other: '{{count}} โรงภาพยนตร์',
  cplMarkers: 'เครื่องหมาย CPL',
  create: 'สร้าง',
  createdOn: 'สร้างเมื่อ',
  creditOffset: 'การหักล้างเครดิต',
  creditsOffset: 'เครดิตออฟเซ็ต',
  dcpStatusTitle: 'สถานะ DCP',
  deactivatedUser: 'ผู้ใช้ที่ถูกปิดใช้งาน',
  delete: 'ลบ',
  deleteIp: 'ลบ IP',
  deleteSuite: 'ลบชุดอุปกรณ์ Suite',
  deleteTheatreGroup: 'ลบกลุ่มโรงภาพยนตร์',
  deleteTheatreGroupConfirmation:
    'คุณแน่ใจหรือไม่ว่าต้องการลบ {{groupName}}? การดำเนินการนี้เป็นการถาวรและไม่สามารถย้อนกลับได้',
  deleteTheatreWarningMessage:
    'การลบจะส่งผลต่อสิทธิ์การเข้าถึง คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?',
  details: 'รายละเอียด',
  deviceWillBeRemoved: 'อุปกรณ์จะถูกลบออกจากชุดอุปกรณ์นี้',
  deviceModel: 'รุ่นอุปกรณ์',
  deviceRole: 'บทบาทอุปกรณ์',
  devices: 'อุปกรณ์',
  deviceWillBeMoved:
    'อุปกรณ์จะถูกย้ายไปยังอุปกรณ์หน้าจอ {{destination}} หลังจากบันทึก',
  deviceWillBeMovedToStandby: 'อุปกรณ์จะถูกย้ายไปยังโหมดสแตนด์บาย',
  disabled: 'ปิดใช้งาน',
  doNotIncludePrDevices: 'อย่ารวมอุปกรณ์ PR สำหรับการสร้าง KDM',
  downloadAttempt: 'การพยายามดาวน์โหลด',
  downloadDetails: 'รายละเอียดการดาวน์โหลด',
  downloadHistory: 'ประวัติการดาวน์โหลด',
  downloadKDMs: 'ดาวน์โหลด KDM',
  downloadLocation: 'ตำแหน่งดาวน์โหลด',
  downloadNow: 'ดาวน์โหลดทันที',
  downloadProgress: '{{progress}} เสร็จสิ้น',
  downloadSize: 'ขนาดการดาวน์โหลด',
  downloadStatus: 'สถานะการดาวน์โหลด',
  duplicateDeviceFound: 'พบอุปกรณ์ซ้ำ',
  duplicateDeviceWarning: 'พบอุปกรณ์ซ้ำใน {{screens_and_suites}}',
  editDevice: 'แก้ไขอุปกรณ์',
  editDeviceMeta: 'แก้ไขข้อมูลอธิบายของอุปกรณ์ Metadata',
  editIp: 'แก้ไข IP',
  editIpHeader: 'แก้ไข IP - หน้าจอ {{screen}}',
  editRoles: 'แก้ไขบทบาท',
  editSuite: 'แก้ไขชุดอุปกรณ์ Suite',
  editSuiteHeader:
    'แก้ไขชุดอุปกรณ์ Suite: หน้าจอ {{screen}} - ชุดอุปกรณ์ {{suite}}',
  editTheatreGroup: 'แก้ไขกลุ่มโรงภาพยนตร์',
  effectiveFrom: 'มีผลตั้งแต่วันที่',
  email: 'อีเมล',
  emailKDMS: 'อีเมล KDM',
  emptyScreen: 'ไม่มีชุดอุปกรณ์ถูกเพิ่มในหน้าจอนี้',
  emptyStandby: 'ไม่มีอุปกรณ์ในสแตนด์บาย',
  enabled: 'เปิดใช้งาน',
  enterEmail: 'กรอกอีเมล',
  enterGateway: 'กรอก เกตเวย์ Gateway',
  enterIpAddress: 'กรอกที่อยู่ IP',
  enterSoftwareVersion: 'กรอกเวอร์ชันซอฟต์แวร์',
  enterSubnetMask: 'กรอก Subnet Mask',
  errorDownloadingKDMs: 'เกิดข้อผิดพลาดในการดาวน์โหลด KDM',
  errorFetching: 'เกิดข้อผิดพลาดขณะดึงข้อมูล',
  errorFetchingDevices: 'เกิดข้อผิดพลาดขณะดึงข้อมูลอุปกรณ์',
  errorFetchingFilterSettings: 'เกิดข้อผิดพลาดขณะดึงการตั้งค่าตัวกรอง',
  errorFetchingGroups: 'เกิดข้อผิดพลาดในการโหลดรายการกลุ่ม',
  errorFetchingUser: 'เกิดข้อผิดพลาดในการโหลดข้อมูลผู้ใช้',
  errorFetchingUsersList: 'เกิดข้อผิดพลาดในการโหลดรายการผู้ใช้',
  errorFetchingWireTapCount: 'เกิดข้อผิดพลาดในการโหลดจำนวน WireTAP ทั้งหมด',
  errorLoadingWireTap: 'เกิดข้อผิดพลาดในการโหลด WireTAP',
  errorMessage: 'เกิดข้อผิดพลาดบางอย่างขณะโหลดผลลัพธ์',
  errorReportDownload:
    'เกิดข้อผิดพลาดในการดาวน์โหลดรายงาน {{report}}: {{error}}',
  errors: {
    fetchDeviceModels: 'เกิดข้อผิดพลาดในการดึงข้อมูลรุ่นอุปกรณ์',
    fetchDeviceRoles: 'เกิดข้อผิดพลาดในการดึงข้อมูลบทบาทอุปกรณ์',
    fetchTheatreInfo: 'เกิดข้อผิดพลาดในการดึงข้อมูลโรงภาพยนตร์',
  },
  errorUploadingCertificate: 'เกิดข้อผิดพลาดในการอัปโหลดใบรับรอง',
  expandAll: 'ขยายทั้งหมด',
  expired: 'หมดอายุแล้ว',
  expiredOn: 'หมดอายุเมื่อวันที่',
  expiring: 'กำลังจะหมดอายุ (ในอีก {{days}} วัน)',
  expiring_1: 'กำลังจะหมดอายุ',
  expiryOn: 'วันหมดอายุ',
  failedToDeleteTheatreGroup: 'ลบกลุ่มโรงภาพยนตร์ไม่สำเร็จ',
  failedToDeleteTheatreGroupMessage: 'เกิดข้อผิดพลาดขณะลบกลุ่มโรงภาพยนตร์',
  failedToRemoveUser: 'ลบผู้ใช้ไม่สำเร็จ',
  failedToSendUserInvite: 'ส่งคำเชิญผู้ใช้ไม่สำเร็จ',
  failedToUpdateUser: 'อัปเดตผู้ใช้ไม่สำเร็จ',
  fetchCompositions: 'เกิดข้อผิดพลาดในการโหลดองค์ประกอบ',
  fetchingRoles: 'กำลังดึงข้อมูลบทบาท...',
  fetchTheatres: 'เกิดข้อผิดพลาดในการโหลดโรงภาพยนตร์',
  filter: 'ตัวกรอง',
  filterBy: 'กรองตาม',
  filterByTheatres: 'กรองตามโรงภาพยนตร์',
  filterPanelCompositionType: 'ประเภทองค์ประกอบ',
  filterPanelCompositionTypeOptions_advertisement: 'โฆษณา',
  filterPanelCompositionTypeOptions_feature: 'ภาพยนตร์เรื่องยาว/ฟีเจอร์',
  filterPanelCompositionTypeOptions_others: 'อื่นๆ',
  filterPanelCompositionTypeOptions_psaPolicy: 'การประชาสัมพันธ์/นโยบาย',
  filterPanelCompositionTypeOptions_trailerTeaserPromo:
    'ตัวอย่างหนัง/ทีเซอร์/โปรโมต',
  filterPanelDcpDownloadStatus: 'สถานะการดาวน์โหลด DCP',
  filterPanelDcpIngestStatus: 'สถานะการนำเข้า DCP',
  filterPanelKdmIngestStatus: 'สถานะการนำเข้า KDM',
  filterPanelKdmStatus: 'สถานะการจัดส่ง KDM',
  filterPanelKdmValidity: 'ความถูกต้องของ KDM',
  filterPanelTheatresPlaceHolder: 'ค้นหาโรงภาพยนตร์',
  filterPanelTheatresTitle: 'โรงภาพยนตร์',
  filters: 'ตัวกรอง',
  from_time_of_booking: 'นับจากเวลาที่จอง',
  fullAccess: 'การเข้าถึงเต็มรูปแบบ',
  future: 'ใช้งานได้ในอนาคต',
  gateway: 'เกตเวย์ Gateway',
  generateReport: 'สร้างรายงาน',
  groupCount_one: '{{count}} กลุ่ม',
  groupCount_other: '{{count}} กลุ่ม',
  groupName: 'ชื่อกลุ่ม',
  groupsCreateGroupCancel: 'ยกเลิก',
  groupsCreateGroupCreateTheatreGroups: 'สร้างกลุ่มโรงภาพยนตร์',
  groupsCreateGroupGroupCreated: 'สร้างกลุ่มเรียบร้อยแล้ว',
  groupsCreateGroupGroupName: 'ชื่อกลุ่ม',
  groupsCreateGroupGroupPlaceHolderName: 'กรอกชื่อกลุ่ม',
  groupsCreateGroupHeaderTitle: 'สร้างกลุ่ม',
  groupsCreateGroupSaveChanges: 'บันทึกการเปลี่ยนแปลง',
  groupsCreateGroupTheatreSelection: 'การเลือกโรงภาพยนตร์',
  groupsHeaderCreateTheatreGroupButton: 'สร้างกลุ่มโรงภาพยนตร์',
  groupsHeaderViewLogsButton: 'ดูบันทึกกิจกรรม Logs',
  groupUpdated: 'อัปเดตกลุ่มเรียบร้อยแล้ว',
  holdoverKdmRequests: 'คำขอ KDM แบบขยายเวลา (Holdover)',
  hour: 'ชั่วโมง',
  iabScreens: 'หน้าจอ IAB',
  inbox: 'กล่องข้อความ',
  invalidEmail: 'ที่อยู่อีเมลไม่ถูกต้อง',
  ipRequired: 'จำเป็นต้องระบุที่อยู่ IP',
  ipAddress: 'ที่อยู่ IP',
  ipAddress_1: 'ที่อยู่ IP',
  ipAlreadySelectedInForm: 'IP นี้ถูกเลือกหรือมอบหมายไปแล้ว โปรดเลือก IP อื่น',
  ipCount_one: 'IP (1)',
  ipCount_other: 'IP ({{count}})',
  kdmDetails: 'รายละเอียด KDM',
  kdmValidityTheatreTimeZone: 'ความถูกต้องของ KDM (เขตเวลาของโรงภาพยนตร์)',
  lastUpdatedBy: 'อัปเดตล่าสุดโดย',
  lastUpdatedOn: 'อัปเดตครั้งล่าสุดเมื่อ',
  linkExpiredOnDownload:
    'ไม่สามารถเริ่มการดาวน์โหลดได้ ลิงก์จัดส่งหมดอายุหรือไม่มีสิทธิ์ดาวน์โหลดอีกต่อไป',
  linkReceivedOn: 'ได้รับลิงก์เมื่อวันที่',
  loading: 'กำลังโหลด',
  location: 'ตำแหน่งที่ตั้ง',
  logsTheatreGroups: 'บันทึกกิจกรรม: กลุ่มโรงภาพยนตร์',
  minute: 'นาที',
  moveModalText:
    'อุปกรณ์ {{name}} จะถูกย้ายไปยังสแตนด์บาย ต้องการดำเนินการต่อหรือไม่?',
  moveTo: 'ย้ายไปที่',
  moveToScreen: 'หน้าจอ {{number}}',
  moveToStandby: 'ย้ายไปสแตนด์บาย',
  moveToStandbyDevices: 'ย้ายไปอุปกรณ์สแตนด์บาย',
  moveToUnmapped: 'ย้ายไปอุปกรณ์หน้าจอ {{number}}',
  movie: 'ภาพยนตร์',
  movieName: 'ชื่อภาพยนตร์',
  multiThumbprintKdm:
    'หน้าจอ Multi Thumbprint KDM ที่ใช้เซิร์ฟเวอร์ DC2 (DCP 2000)',
  multiThumbprintKdmOtherServices:
    'หน้าจอ Multi Thumbprint KDM ที่ใช้เซิร์ฟเวอร์อื่น',
  name: 'ชื่อ',
  needs_1_SM_RMB_msg:
    'ทุกชุดอุปกรณ์ต้องมี 1 SM/1 RMB อย่างแม่นยำ โปรดเพิ่มอุปกรณ์ SM/RMB พร้อมใบรับรองเพื่อดำเนินการต่อ',
  newData: 'ข้อมูลใหม่',
  newRequestCreated: 'สร้างคำขอใหม่แล้วด้วยรหัสคำขอ {{requestId}}',
  no_compositions: 'ไม่มีองค์ประกอบ',
  no_theatres: 'ไม่มีโรงภาพยนตร์ที่พร้อมใช้งาน',
  noAccess: 'ไม่สามารถเข้าถึงได้',
  noBookings: 'ไม่มีรายการจอง',
  noData: 'ไม่มีข้อมูล',
  noExpiredBookings: 'ไม่พบการดาวน์โหลด WireLink ที่หมดอายุ',
  noIpFound: 'ไม่มี IP ที่พร้อมใช้งาน',
  noMatchFound: 'ไม่พบข้อมูลที่ตรงกัน',
  noResultsFound: 'ไม่พบผลลัพธ์',
  normalKdm: 'KDM ปกติ',
  notDownloaded: 'ยังไม่ได้ดาวน์โหลด',
  notSelected: 'ไม่ได้เลือก',
  noWiretapAvailable: 'ไม่มี WireTAP ที่พร้อมใช้งาน',
  oldData: 'ข้อมูลเก่า',
  optional: 'ไม่บังคับ',
  osVersion: 'เวอร์ชันระบบปฏิบัติการ',
  pending: 'กำลังดำเนินการ',
  readyToDownload: 'พร้อมดาวน์โหลด',
  receivedOn: 'ได้รับเมื่อวันที่',
  recipientDetails: 'รายละเอียดผู้รับ',
  recipientEmails: 'อีเมลผู้รับ',
  remove: 'ลบ',
  removeFromTheatre: 'ลบออกจากโรงภาพยนตร์',
  removeModalText: 'คุณแน่ใจหรือไม่ว่าต้องการลบ {{name}} ออกจากโรงภาพยนตร์?',
  removeUser: 'ลบผู้ใช้',
  removeUserConfirmation:
    'การลบผู้ใช้รายนี้จะยกเลิกสิทธิ์การเข้าถึงจากบริษัท ผู้ใช้จะไม่สามารถเข้าสู่ระบบหรือดำเนินการใดๆ ได้',
  reportInitiated: 'เริ่มดำเนินการรายงาน {{report}} แล้ว',
  reportReady: 'รายงาน {{report}} พร้อมใช้งานแล้ว',
  reportsheaderTitle: 'รายงาน',
  requestedBy: 'ร้องขอโดย',
  requestedKdmValidity: 'ความถูกต้องของ KDM ที่ร้องขอ',
  requestedOn: 'ร้องขอเมื่อ',
  requestFailed: 'คำขอล้มเหลว',
  requestFailedMessage: 'ส่งคำขอไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
  requestSent: 'ส่งคำขอเรียบร้อยแล้ว',
  role: 'บทบาท',
  roles: 'บทบาท',
  save: 'บันทึก',
  saveChanges: 'บันทึกการเปลี่ยนแปลง',
  screen: 'หน้าจอ',
  screenInactive: 'ไม่ใช้งานอยู่',
  screens: 'หน้าจอ',
  searchByLocation: 'ค้นหาตามตำแหน่งที่ตั้ง',
  searchByNameOrEmail: 'ค้นหาตามชื่อหรืออีเมล',
  searchBySerialNo: 'ค้นหาตามหมายเลขซีเรียล',
  searchByTheatreGroup: 'ค้นหาตามกลุ่มโรงภาพยนตร์',
  searchByTheatreGroupName: 'ค้นหาตามชื่อกลุ่มโรงภาพยนตร์',
  searchByTheatreName: 'ค้นหาตามชื่อโรงภาพยนตร์',
  searchCompositions: 'ค้นหาตามชื่อองค์ประกอบ',
  searchCompositionsPlaceholder: 'ค้นหาองค์ประกอบ',
  searchDeviceModel: 'ค้นหารุ่นอุปกรณ์',
  searchForChain: 'ค้นหาเครือโรงภาพยนตร์',
  searchForLocation: 'ค้นหาตำแหน่งที่ตั้ง',
  searchForOsVersion: 'ค้นหาเวอร์ชันระบบปฏิบัติการ',
  searchForPublicIp: 'ค้นหา IP สาธารณะ',
  searchForSerialNumber: 'ค้นหาหมายเลขซีเรียล',
  searchForTheatre: 'ค้นหาโรงภาพยนตร์',
  searchForWiretap: 'ค้นหา WireTAP',
  searchMovies: 'ค้นหาภาพยนตร์',
  searchPlaceholder: 'ค้นหาโรงภาพยนตร์ที่คุณจัดการ',
  searchSerialNumber: 'ค้นหาหมายเลขซีเรียล',
  searchTheatres: 'ค้นหาโรงภาพยนตร์',
  selectIpAddress: 'เลือกที่อยู่ IP',
  selectRole: 'เลือกบทบาท',
  sendInvite: 'ส่งคำเชิญ',
  serialNumber: 'หมายเลขซีเรียล',
  serialNumber_1: 'หมายเลขซีเรียล',
  show: 'แสดง',
  showingCountResults_one: 'กำลังแสดง 1 ผลลัพธ์สำหรับ',
  showingCountResults_other: 'กำลังแสดง {{count}} ผลลัพธ์สำหรับ',
  showingResults:
    'กำลังแสดงรายการที่ {{start}}-{{end}} จากทั้งหมด {{total}} รายการ',
  showingResultsFor: 'แสดงผลลัพธ์สำหรับ',
  showMore: 'แสดงเพิ่มเติม',
  softwareVersion: 'เวอร์ชันซอฟต์แวร์',
  somethingWentWrong: 'เกิดข้อผิดพลาด!',
  standby: 'สแตนด์บาย',
  standbyDevices: 'อุปกรณ์สแตนด์บาย',
  standbyHeader_one: 'อุปกรณ์สแตนด์บาย (1)',
  standbyHeader_other: 'อุปกรณ์สแตนด์บาย ({{count}})',
  status: 'สถานะ',
  subnetMask: 'Subnet Mask',
  suite: 'ชุดอุปกรณ์ Suite',
  suiteCreationRules: 'กฎการสร้างชุดอุปกรณ์ Suite',
  suiteDevicesExpiredMsg: 'ชุดอุปกรณ์มีอุปกรณ์ที่ใบรับรองหมดอายุแล้ว',
  suiteEffectiveFrom: 'ชุดอุปกรณ์มีผลตั้งแต่วันที่',
  suiteInvalid: 'ชุดอุปกรณ์ไม่ถูกต้องสำหรับการสร้าง KDM',
  suiteLogs: 'บันทึกกิจกรรมชุดอุปกรณ์ Suite Logs',
  suiteMustContain:
    'ชุดอุปกรณ์ต้องมีอุปกรณ์ SM {{smCount}} เครื่อง หรือ RMB {{rmbCount}} เครื่อง อย่างแม่นยำ',
  suiteMustContainAdLd:
    'ชุดอุปกรณ์ต้องมีอุปกรณ์เพิ่มเติมอย่างน้อย 1 เครื่องที่มีบทบาทอุปกรณ์เป็น LD',
  suiteMustContainLDorPR:
    'ชุดอุปกรณ์ต้องมีอุปกรณ์เพิ่มเติมอย่างน้อย 1 เครื่องที่มีบทบาทอุปกรณ์เป็น LD หรือ PR',
  suiteMustContainSm:
    'ชุดอุปกรณ์ต้องมีอุปกรณ์ SM {{smCount}} เครื่อง อย่างแม่นยำ',
  suiteMustContainSMOBE:
    'ชุดอุปกรณ์ต้องมี 1 SM / OBAE ร่วมกับอุปกรณ์ SM อย่างแม่นยำ',
  suiteNo: 'ชุดอุปกรณ์ {{number}}',
  theatre: 'โรงภาพยนตร์',
  theatre_1: 'โรงภาพยนตร์',
  theatre_header: 'โรงภาพยนตร์',
  theatreCount: 'จำนวนโรงภาพยนตร์',
  theatreGroup: 'กลุ่มโรงภาพยนตร์',
  theatreGroupDeleted: 'ลบกลุ่มโรงภาพยนตร์แล้ว',
  theatreGroupDeletedMessage: 'ลบ {{groupName}} เรียบร้อยแล้ว',
  theatreGroupDetails: 'รายละเอียดกลุ่มโรงภาพยนตร์',
  theatreGroups: 'กลุ่มโรงภาพยนตร์',
  theatreName: 'ชื่อโรงภาพยนตร์',
  theatres: 'โรงภาพยนตร์',
  theatresList: 'รายการโรงภาพยนตร์',
  theatreSmall: 'โรงภาพยนตร์',
  theatreTimeZone: 'เขตเวลาโรงภาพยนตร์',
  trackingInfo: 'ข้อมูลการติดตาม',
  unarchival_may_take: 'การยกเลิกการจัดเก็บอาจใช้เวลา',
  undo: 'เลิกทำ',
  unmappedDevices_one: 'อุปกรณ์ (1)',
  unmappedDevices_other: 'อุปกรณ์ ({{count}})',
  untitled: 'ไม่มีชื่อเรื่อง',
  update: 'อัปเดต',
  updatedBy: 'อัปเดตโดย',
  updatedOn: 'อัปเดตเมื่อ',
  uploadCertificate: 'อัปโหลดใบรับรอง',
  uploadDeviceCertificate: 'อัปโหลดใบรับรองอุปกรณ์',
  user: 'ผู้ใช้',
  userCount_one: '{{1}} ผู้ใช้',
  userCount_other: '{{count}} ผู้ใช้',
  userInviteSent: 'ส่งคำเชิญผู้ใช้เรียบร้อยแล้ว',
  userLogs: 'บันทึกกิจกรรมผู้ใช้',
  userRemoved: 'ลบผู้ใช้แล้ว',
  users: 'ผู้ใช้',
  usersHeaderButtonsInviteUser: 'เชิญผู้ใช้',
  usersHeaderButtonsViewLogs: 'ดูบันทึกกิจกรรม Logs',
  usersHeaderTitle: 'จัดการผู้ใช้',
  validFrom: 'มีผลตั้งแต่',
  validNow: 'ใช้งานได้ในขณะนี้',
  validTo: 'ใช้ได้จนถึง',
  verificationStatus: 'สถานะการตรวจสอบความถูกต้อง',
  viewAll: 'ดูทั้งหมด',
  viewAllTheatreGroups: 'ดูกลุ่มโรงภาพยนตร์ทั้งหมด',
  viewCreditOffset: 'เครดิต: {{value}}',
  viewSuiteLogs: 'ดูบันทึกกิจกรรมชุดอุปกรณ์ Suite Logs',
  viewTheatreGroup: 'ดูกลุ่มโรงภาพยนตร์',
  warning: 'คำเตือน',
  wireLinkCopiedToClipboard: 'คัดลอก WireLink ไปยังคลิปบอร์ดแล้ว',
  wireLinkCopyFailed: 'ไม่สามารถคัดลอกได้ กรุณาลองใหม่อีกครั้ง',
  wireLinkDetails: 'รายละเอียด WireLink',
  wireLinks: 'WireLinks',
  wiretaps: 'WireTAPs',
  wiretapStatusReport: 'รายงานสถานะ WireTAP',
  removeDevice: 'ลบอุปกรณ์',
  deleteIpTitle: 'ลบที่อยู่ IP - {{ip}}',
  appliances: 'อุปกรณ์',
  noResultsFor: 'ไม่พบผลลัพธ์สำหรับ',
  city: 'เมือง',
  province: 'จังหวัด',
  country: 'ประเทศ',
  confirmAction: 'ยืนยันการกระทำ',
  RequestId: 'รหัสคำขอ: {{requestId}}',
  moveToUnmapped_name: 'ย้ายไปยังอุปกรณ์ {{name}}',
  language: 'ภาษา',
  subtitleLanguage: 'ภาษาของคำบรรยาย',
  mainCaption: 'คำบรรยายหลัก',
  ratings: 'การให้คะแนน',
  type: 'ประเภท',
  dciStandard: 'มาตรฐาน DCI',
  closedSubtitles: 'คำบรรยายปิด',
  frameRate: 'อัตราเฟรม',
  audioFormats: 'รูปแบบเสียง',
  resolution: 'ความละเอียด',
  closedCaptions: 'คำบรรยายปิด',
  stereoType: 'ประเภทสเตอริโอ',
  aspectRatio: 'อัตราส่วนภาพ',
};
